(function () {
  if (window.ejsPillMoreBound) return;
  window.ejsPillMoreBound = true;

  var tip = document.createElement('div');
  tip.className = 'ejs-pill-more-tip';
  tip.setAttribute('role', 'tooltip');
  tip.hidden = true;
  document.body.appendChild(tip);

  var current = null;
  var hideTimer = 0;
  var frame = 0;

  function namesOf(el) {
    return (el.getAttribute('data-more') || '')
      .split('|||')
      .map(function (name) { return name.trim(); })
      .filter(Boolean);
  }

  function finishHide() {
    if (tip.classList.contains('is-in')) return;
    tip.hidden = true;
    tip.replaceChildren();
  }

  function hide(immediate) {
    current = null;
    cancelAnimationFrame(frame);
    tip.classList.remove('is-in');
    clearTimeout(hideTimer);
    if (immediate) {
      finishHide();
      return;
    }
    hideTimer = setTimeout(finishHide, 180);
  }

  function place(el) {
    var rect = el.getBoundingClientRect();
    var card = el.closest('.ejs-product-card, product-card, .product-card');
    var bounds = card ? card.getBoundingClientRect() : rect;
    var gap = 10;
    tip.style.maxWidth = Math.max(96, Math.round(bounds.width - 16)) + 'px';
    var width = tip.offsetWidth;
    var height = tip.offsetHeight;
    var left = rect.right - width;
    var minLeft = bounds.left + 8;
    var maxLeft = bounds.right - width - 8;
    if (maxLeft < minLeft) maxLeft = minLeft;
    left = Math.min(Math.max(left, minLeft), maxLeft);
    var top = rect.top - height - gap;
    if (top < bounds.top + 8) top = bounds.top + 8;

    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
  }

  function toneList(el) {
    return (el.getAttribute('data-tones') || '')
      .split('|||')
      .map(function (tone) { return tone.trim(); });
  }

  function paint(node, source) {
    var style = source;
    if (source && source.nodeType === 1) style = getComputedStyle(source);
    node.style.backgroundColor = style.backgroundColor;
    node.style.color = style.color;
    node.style.borderColor = style.borderColor;
  }

  function toneStyle(className) {
    var probe = document.createElement('span');
    probe.className = 'ejs-product-pill ' + className;
    probe.style.cssText = 'position:fixed;left:-9999px;top:0;visibility:hidden;';
    document.body.appendChild(probe);
    var style = getComputedStyle(probe);
    var colors = {
      backgroundColor: style.backgroundColor,
      color: style.color,
      borderColor: style.borderColor
    };
    probe.remove();
    return colors;
  }

  function show(el) {
    var names = namesOf(el);
    if (!names.length) return;
    var tones = toneList(el);
    var unique = tones.filter(function (tone, index) {
      return tone && tones.indexOf(tone) === index;
    });
    current = el;
    tip.replaceChildren();
    tip.style.backgroundColor = '';
    tip.style.color = '';
    tip.style.borderColor = '';
    names.forEach(function (name, index) {
      var row = document.createElement('span');
      row.className = 'ejs-pill-more-tip__name';
      row.textContent = name;
      if (unique.length > 1 && tones[index]) paint(row, toneStyle(tones[index]));
      tip.appendChild(row);
    });
    if (unique.length <= 1) paint(tip, el);
    clearTimeout(hideTimer);
    tip.hidden = false;
    place(el);
    cancelAnimationFrame(frame);
    tip.classList.remove('is-in');
    frame = requestAnimationFrame(function () {
      frame = requestAnimationFrame(function () {
        if (current === el) tip.classList.add('is-in');
      });
    });
  }

  document.addEventListener('pointerover', function (event) {
    var el = event.target.closest && event.target.closest('.ejs-product-pill.more-bundles');
    if (!el || el === current) return;
    show(el);
  });

  document.addEventListener('pointerout', function (event) {
    var el = event.target.closest && event.target.closest('.ejs-product-pill.more-bundles');
    if (!el || el !== current) return;
    if (el.contains(event.relatedTarget)) return;
    hide();
  });

  document.addEventListener('focusin', function (event) {
    var el = event.target.closest && event.target.closest('.ejs-product-pill.more-bundles');
    if (el) show(el);
  });

  document.addEventListener('focusout', function (event) {
    var el = event.target.closest && event.target.closest('.ejs-product-pill.more-bundles');
    if (el && el === current) hide();
  });

  window.addEventListener('scroll', function () { hide(true); }, true);
  window.addEventListener('resize', function () { hide(true); });
})();
